import parse from "date-fns/parse"

export const parseDateLong = (date) => parse(date, "d MMM yyyy", new Date())
export const parseDateShort = (date) => parse(date, "d/M/yy", new Date())
export const parseDateISO = (date) => parse(date, "yyyy-MM-d", new Date())
export const parseDateUrl = (date) => parse(date, "yyyyMMd", new Date())
